import { render, staticRenderFns } from "./RecebimentoPromissorias.vue?vue&type=template&id=16fca9a2&scoped=true&"
import script from "./RecebimentoPromissorias.vue?vue&type=script&lang=js&"
export * from "./RecebimentoPromissorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fca9a2",
  null
  
)

export default component.exports